import { memo } from 'react';

/**
 * Sidebar icon for the medical awareness cards: a framed picture with a link
 * arrow leaving it, which is what the feature is — a photo you tap to go
 * somewhere.
 *
 * Written rather than reusing `Info`, whose stroke is hard-coded to white for
 * the "Contact us info" button on its dark background. Dropped into the
 * sidebar it renders white on white, so the nav item would appear to have no
 * icon at all. This follows `Reminder` instead: the stroke tracks the active
 * state so the selected item darkens with the rest of the list.
 */
const SvgComponent = (props: any) => {
  const stroke = props.active ? 'black' : '#808080';

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 10.8333V5C17.5 4.55797 17.3244 4.13405 17.0118 3.82149C16.6993 3.50893 16.2754 3.33333 15.8333 3.33333H4.16667C3.72464 3.33333 3.30072 3.50893 2.98816 3.82149C2.67559 4.13405 2.5 4.55797 2.5 5V15C2.5 15.442 2.67559 15.866 2.98816 16.1785C3.30072 16.4911 3.72464 16.6667 4.16667 16.6667H10"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 13.3333L6.66667 9.16667L11.25 13.75"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12.9167" cy="7.08333" r="1.25" stroke={stroke} />
      <path
        d="M13.3333 17.5H17.5V13.3333M17.5 17.5L13.75 13.75"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Memo = memo(SvgComponent);

export default Memo;
